$.fn.plusItem = function () {
  let $btn, $items;

  $btn = $(this).find('.js-plus-item-btn'),
  $items = $(this).find('.item');

  if ($(window).innerWidth() > 991) {
    if ($items.length > 8) {
      $(this).find('.item:lt(8)').removeClass('d-none');
      $btn.removeClass('d-none');
    } else {
      $btn.addClass('d-none');
      $items.removeClass('d-none');
    }
  } else {
    if ($items.length > 6) {
      $(this).find('.item:lt(6)').removeClass('d-none');
      $btn.removeClass('d-none');
    } else {
      $btn.addClass('d-none');
      $items.removeClass('d-none');
    }
  }

  $btn.find('label').text('+' + $(this).find('.item.d-none').length);

  $btn.click(function () {
    $items.each(function () {
      setTimeout(() => {
        $(this).removeClass('d-none').fadeIn('slow');
      }, $(this).index() * 50);
    });
    $(this).addClass('d-none');
  });

  return this;
};




// WEBPACK FOOTER //
// ./scripts/util/plusItem.js